module.exports = __webpack_public_path__ + "img/Asset-203-100.c61fb39f.jpg";